import { useQuery } from "react-query";

import { POSITIONS_QUERY_KEY } from "./useGetPositions";
import { usePositions } from "./usePositions";

export const useGetPositionById = (
  instanceId: number | string,
  enabled = true
) => {
  const { positionGetById } = usePositions();

  const { data, isLoading, isError } = useQuery({
    queryKey: [POSITIONS_QUERY_KEY, "byId", String(instanceId)],
    queryFn: () => positionGetById(instanceId),
    enabled: enabled && !!instanceId,
  });

  return {
    position: data?.data?.position,
    isLoading,
    isError,
  };
};
